import arrowRight from "@/assets/images/arrow-right.svg";

type CardProps = {
  labelText: string;
  informationText?: string | null;
  iconType?: "editable" | "readonly";
  type?: "tel" | "string";
  visible?: boolean;
  onClick?: () => void;
  selectedCountryCode?: string | null;
};

export default function Card({ visible = true, ...props }: CardProps) {
  return (
    <div className="cursor-pointer shadow-lg rounded-md bg-[var(--surface-default)] border border-[var(--outline-default-variant)] transition-all duration-500 hover:bg-[var(--surface-default-variant)]" onClick={props.onClick}>
      <div className={"flex justify-between cursor-pointer text-base py-8 pr-6   box-border"}>
        <div className="flex flex-col cursor-pointer">
          <label className="font-medium ml-6 cursor-pointer text-[var(--on-surface-default)]">{props.labelText}</label>
          <label className="ml-6 cursor-pointer text-xs text-[var(--on-surface-default)]">{visible ? props.informationText : "••••••"}</label>
        </div>
        <div className="flex flex-col justify-center">
          <img src={arrowRight} alt="" />
        </div>
      </div>
    </div>
  );
}
